
import { WorldCity } from '../types';

// Expansión de República Checa - 80 ciudades adicionales
export const czechRepublicAdditionalCities: WorldCity[] = [
  { name: 'Brno', slug: 'brno', population: 379527 },
  { name: 'Ostrava', slug: 'ostrava', population: 287968 },
  { name: 'Plzen', slug: 'plzen', population: 169033 },
  { name: 'Liberec', slug: 'liberec', population: 103288 },
  { name: 'Olomouc', slug: 'olomouc', population: 100663 },
  { name: 'Budejovice', slug: 'budejovice', population: 93285 },
  { name: 'Hradec Kralove', slug: 'hradec-kralove', population: 92808 },
  { name: 'Usti nad Labem', slug: 'usti-nad-labem', population: 92716 },
  { name: 'Pardubice', slug: 'pardubice', population: 89467 },
  { name: 'Havirov', slug: 'havirov', population: 75049 },
  { name: 'Zlin', slug: 'zlin', population: 75112 },
  { name: 'Kladno', slug: 'kladno', population: 68896 },
  { name: 'Most', slug: 'most', population: 66910 },
  { name: 'Opava', slug: 'opava', population: 57676 },
  { name: 'Frydek-Mistek', slug: 'frydek-mistek', population: 56945 },
  { name: 'Karviná', slug: 'karvina', population: 55985 },
  { name: 'Jihlava', slug: 'jihlava', population: 50009 },
  { name: 'Teplice', slug: 'teplice', population: 50079 },
  { name: 'Decin', slug: 'decin', population: 49833 },
  { name: 'Karlovy Vary', slug: 'karlovy-vary', population: 48939 },
  { name: 'Jablonec nad Nisou', slug: 'jablonec-nad-nisou', population: 45602 },
  { name: 'Mlada Boleslav', slug: 'mlada-boleslav', population: 44661 },
  { name: 'Prostejov', slug: 'prostejov', population: 44141 },
  { name: 'Prerov', slug: 'prerov', population: 42009 },
  { name: 'Chomutov', slug: 'chomutov', population: 48635 },
  { name: 'Trinec', slug: 'trinec', population: 35884 },
  { name: 'Tabor', slug: 'tabor', population: 34327 },
  { name: 'Znojmo', slug: 'znojmo', population: 33876 },
  { name: 'Pribram', slug: 'pribram', population: 33688 },
  { name: 'Cheb', slug: 'cheb', population: 32792 },
  { name: 'Trutnov', slug: 'trutnov', population: 30787 },
  { name: 'Orlová', slug: 'orlova', population: 29206 },
  { name: 'Ceske Budejovice', slug: 'ceske-budejovice', population: 93285 },
  { name: 'Nachod', slug: 'nachod', population: 21705 },
  { name: 'Sumperk', slug: 'sumperk', population: 26296 },
  { name: 'Uherske Hradiste', slug: 'uherske-hradiste', population: 25034 },
  { name: 'Brevnov', slug: 'brevnov', population: 41208 },
  { name: 'Kolin', slug: 'kolin', population: 31279 },
  { name: 'Pisek', slug: 'pisek', population: 29909 },
  { name: 'Kutna Hora', slug: 'kutna-hora', population: 20658 },
  { name: 'Jindrichuv Hradec', slug: 'jindrichuv-hradec', population: 21867 },
  { name: 'Kralupy nad Vltavou', slug: 'kralupy-nad-vltavou', population: 17399 },
  { name: 'Litomerice', slug: 'litomerice', population: 24131 },
  { name: 'Hodonin', slug: 'hodonin', population: 25241 },
  { name: 'Rosice', slug: 'rosice', population: 5867 },
  { name: 'Krnov', slug: 'krnov', population: 23934 },
  { name: 'Sokolov', slug: 'sokolov', population: 23287 },
  { name: 'Novy Jicin', slug: 'novy-jicin', population: 22580 },
  { name: 'Ceska Lipa', slug: 'ceska-lipa', population: 37258 },
  { name: 'Strakonice', slug: 'strakonice', population: 22596 },
  { name: 'Svitavy', slug: 'svitavy', population: 16647 },
  { name: 'Valasske Mezirici', slug: 'valasske-mezirici', population: 22313 },
  { name: 'Litvinov', slug: 'litvinov', population: 24119 },
  { name: 'Unhost', slug: 'unhost', population: 21591 },
  { name: 'Beroun', slug: 'beroun', population: 19844 },
  { name: 'Tisnov', slug: 'tisnov', population: 8641 },
  { name: 'Ostrov', slug: 'ostrov', population: 16668 },
  { name: 'Klatovy', slug: 'klatovy', population: 22548 },
  { name: 'Cesky Tesin', slug: 'cesky-tesin', population: 23155 },
  { name: 'Vsetin', slug: 'vsetin', population: 25661 },
  { name: 'Rychnov nad Kneznou', slug: 'rychnov-nad-kneznou', population: 11467 },
  { name: 'Brandys nad Labem', slug: 'brandys-nad-labem', population: 19805 },
  { name: 'Pelhrimov', slug: 'pelhrimov', population: 16006 },
  { name: 'Domazlice', slug: 'domazlice', population: 11139 },
  { name: 'Beclav', slug: 'beclav', population: 11782 },
  { name: 'Kromeriz', slug: 'kromeriz', population: 28739 },
  { name: 'Tachov', slug: 'tachov', population: 12547 },
  { name: 'Litomysl', slug: 'litomysl', population: 10077 },
  { name: 'Ceska Trebova', slug: 'ceska-trebova', population: 16228 },
  { name: 'Ricany', slug: 'ricany', population: 18773 },
  { name: 'Zatec', slug: 'zatec', population: 19085 },
  { name: 'Turnov', slug: 'turnov', population: 14455 },
  { name: 'Roznov pod Radhostem', slug: 'roznov-pod-radhostem', population: 16757 },
  { name: 'Usti nad Orlici', slug: 'usti-nad-orlici', population: 14207 },
  { name: 'Vizovice', slug: 'vizovice', population: 4570 },
  { name: 'Humpolec', slug: 'humpolec', population: 10859 },
  { name: 'Caslav', slug: 'caslav', population: 15421 },
  { name: 'Dvur Kralove nad Labem', slug: 'dvur-kralove-nad-labem', population: 15792 },
  { name: 'Melnik', slug: 'melnik', population: 19758 },
  { name: 'Neratovice', slug: 'neratovice', population: 16784 },
  { name: 'Jesenik', slug: 'jesenik', population: 11677 },
  { name: 'Rakovnik', slug: 'rakovnik', population: 16116 },
  { name: 'Bystrice nad Pernstejnem', slug: 'bystrice-nad-pernstejnem', population: 8567 },
  { name: 'Pacov', slug: 'pacov', population: 4853 }
];

export const czechRepublicExpanded = {
  code: 'CZ',
  name: 'Czech Republic',
  slug: 'czech-republic',
  population: 10708981,
  topCities: [
    { name: 'Prague', slug: 'prague', population: 1318000 },
    ...czechRepublicAdditionalCities
  ]
};
